/* KBM Fabrics — Wishlist (login-required, localStorage-backed, scoped per customer) */
(function() {
  'use strict';

  function getStorageKey() {
    var cid = (document.body && document.body.dataset && document.body.dataset.customerId) || '';
    return cid ? 'kbm_wishlist_' + cid : 'kbm_wishlist_guest';
  }
  function isLoggedIn() { return document.body && document.body.dataset && document.body.dataset.customerLoggedIn === '1'; }

  function getWishlist() {
    try { var raw = localStorage.getItem(getStorageKey()); return raw ? JSON.parse(raw) : []; } catch (e) { return []; }
  }
  function saveWishlist(items) {
    try { localStorage.setItem(getStorageKey(), JSON.stringify(items)); } catch (e) {}
    refreshUI();
  }
  function toggleItem(product) {
    var items = getWishlist();
    var idx = items.findIndex(function(i){ return String(i.id) === String(product.id); });
    if (idx >= 0) items.splice(idx, 1);
    else items.push({ id: product.id, handle: product.handle, title: product.title || '', image: product.image || '', price: product.price || '', addedAt: Date.now() });
    saveWishlist(items);
  }

  /* === Login-required modal === */
  function showLoginModal(pendingProductId) {
    if (document.getElementById('kbm-wishlist-login-modal')) return;
    var ret = encodeURIComponent(location.pathname + (location.search || ''));
    var loginUrl = '/account/login?return_url=' + ret + (pendingProductId ? '&kbm_wish=' + encodeURIComponent(pendingProductId) : '');
    var registerUrl = '/account/register?return_url=' + ret + (pendingProductId ? '&kbm_wish=' + encodeURIComponent(pendingProductId) : '');
    var overlay = document.createElement('div');
    overlay.id = 'kbm-wishlist-login-modal';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,0.55);display:flex;align-items:center;justify-content:center;padding:20px;backdrop-filter:blur(4px);animation:kbmFade 0.2s ease;';
    overlay.innerHTML =
      '<div style="background:#fff;border-radius:18px;max-width:420px;width:100%;padding:36px 32px;text-align:center;box-shadow:0 25px 60px rgba(0,0,0,0.25);font-family:-apple-system,system-ui,sans-serif;">'+
        '<div style="font-size:48px;margin-bottom:12px;">❤️</div>'+
        '<h3 style="font-family:\'Playfair Display\',Georgia,serif;font-size:24px;margin:0 0 10px;color:#1a1a1a;">Sign in to save fabrics</h3>'+
        '<p style="font-size:14px;color:#6b6b6b;margin:0 0 24px;line-height:1.5;">Create an account or sign in to save fabrics to your wishlist. They\'ll be waiting in your account.</p>'+
        '<a href="'+loginUrl+'" style="display:block;padding:14px;background:#DC2F2F;color:#fff;text-decoration:none;border-radius:999px;font-weight:700;font-size:13px;letter-spacing:1px;text-transform:uppercase;margin-bottom:10px;">Sign in</a>'+
        '<a href="'+registerUrl+'" style="display:block;padding:14px;background:transparent;color:#1a1a1a;text-decoration:none;border-radius:999px;font-weight:700;font-size:13px;letter-spacing:1px;text-transform:uppercase;border:1px solid #ddd;margin-bottom:14px;">Create account</a>'+
        '<button type="button" id="kbm-wl-modal-close" style="background:none;border:none;color:#888;font-size:13px;cursor:pointer;text-decoration:underline;">Not now</button>'+
      '</div>';
    document.body.appendChild(overlay);
    var closeBtn = document.getElementById('kbm-wl-modal-close');
    function close() { overlay.remove(); }
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function(e){ if (e.target === overlay) close(); });
    document.addEventListener('keydown', function onEsc(e){ if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onEsc); } });
  }

  /* === UI sync === */
  function refreshUI() {
    var items = getWishlist();
    var ids = items.map(function(i){ return String(i.id); });
    var hasItems = items.length > 0;
    document.querySelectorAll('.kbm-wishlist-btn').forEach(function(btn) {
      var id = btn.getAttribute('data-product-id');
      var active = ids.includes(String(id));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', isLoggedIn() ? (active ? 'Remove from saved fabrics' : 'Save fabric') : 'Sign in to save');
    });
    document.querySelectorAll('.kbm-wishlist-count').forEach(function(el) {
      el.textContent = items.length;
      el.style.display = hasItems ? '' : 'none';
      var li = el.closest('li'); if (li) li.style.display = hasItems ? '' : 'none';
    });
  }

  /* === Click handler === */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.kbm-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var productId = btn.getAttribute('data-product-id');
    if (!isLoggedIn()) { showLoginModal(productId); return; }
    toggleItem({
      id: productId,
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price')
    });
  });

  /* === Handle pending save after login redirect === */
  function handlePendingSave() {
    if (!isLoggedIn()) return;
    var params = new URLSearchParams(location.search);
    var pendingId = params.get('kbm_wish');
    if (!pendingId) return;
    var btn = document.querySelector('.kbm-wishlist-btn[data-product-id="' + pendingId + '"]');
    if (btn) {
      toggleItem({
        id: pendingId,
        handle: btn.getAttribute('data-product-handle'),
        title: btn.getAttribute('data-product-title'),
        image: btn.getAttribute('data-product-image'),
        price: btn.getAttribute('data-product-price')
      });
      var toast = document.createElement('div');
      toast.textContent = 'Saved to your wishlist';
      toast.style.cssText = 'position:fixed;bottom:30px;left:50%;transform:translateX(-50%);background:#1d9e75;color:#fff;padding:14px 28px;border-radius:999px;font-weight:600;z-index:10000;box-shadow:0 8px 24px rgba(0,0,0,0.2);';
      document.body.appendChild(toast);
      setTimeout(function(){ toast.remove(); }, 3000);
    }
    var url = new URL(location.href); url.searchParams.delete('kbm_wish');
    history.replaceState({}, '', url.toString());
  }

  /* === Wishlist page renderer === */
  function escapeHtml(s) { return String(s||'').replace(/[&<>"']/g, function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];}); }

  function renderWishlistPage() {
    var container = document.getElementById('kbm-wishlist-container');
    if (!container) return;
    var emptyEl = document.getElementById('kbm-wishlist-empty');
    var items = getWishlist();
    if (items.length === 0) {
      if (emptyEl) emptyEl.style.display = '';
      container.innerHTML = '';
      return;
    }
    if (emptyEl) emptyEl.style.display = 'none';
    container.innerHTML = '<div class="kbm-wishlist-loading">Loading your saved fabrics…</div>';
    Promise.all(items.map(function(item){
      return fetch('/products/' + item.handle + '.js').then(function(r){ if (!r.ok) throw new Error(); return r.json(); }).catch(function(){ return { _missing: true, id: item.id, handle: item.handle, title: item.title }; });
    })).then(function(products){
      container.innerHTML = products.map(function(p){
        if (p._missing) {
          return '<div class="kbm-wishlist-card kbm-wishlist-missing"><div class="kbm-wishlist-info"><h3>'+escapeHtml(p.title||'Removed product')+'</h3><p class="kbm-wishlist-note">No longer available.</p></div><button class="kbm-wishlist-btn is-active kbm-wishlist-remove" data-product-id="'+p.id+'"><span>Remove</span></button></div>';
        }
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var price = (p.price/100).toFixed(2);
        var compareAt = p.compare_at_price ? (p.compare_at_price/100).toFixed(2) : null;
        return '<div class="kbm-wishlist-card"><a href="/products/'+p.handle+'" class="kbm-wishlist-img-link"><img src="'+img+'" alt="'+escapeHtml(p.title)+'" loading="lazy"></a><div class="kbm-wishlist-info"><a href="/products/'+p.handle+'"><h3>'+escapeHtml(p.title)+'</h3></a><p class="kbm-wishlist-price">$'+price+(compareAt?' <s>$'+compareAt+'</s>':'')+'</p><div class="kbm-wishlist-actions"><a href="/products/'+p.handle+'" class="kbm-wishlist-view">View</a><button class="kbm-wishlist-btn is-active kbm-wishlist-remove" data-product-id="'+p.id+'" data-product-handle="'+p.handle+'"><span>Remove</span></button></div></div></div>';
      }).join('');
      refreshUI();
    });
  }

  /* === Init === */
  function init() {
    refreshUI();
    handlePendingSave();
    renderWishlistPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', refreshUI);

  window.KBMWishlist = { get: getWishlist, refresh: refreshUI, isLoggedIn: isLoggedIn };
})();
